const styles = theme => ({
  root: {
    paddingBottom: 5,
    width: 385,
    [theme.breakpoints.down(450)]: {
      width: '100%',
    }
  },
  rating: {
    paddingTop: 20,
    [theme.breakpoints.down(450)]: {
      justifyContent: 'space-between',
    }
  },
  item: {
    display: 'inline-block',
    width: 48,
    height: 48,
    fontSize: 24,
    lineHeight: '46px',
    fontFamily: 'Roboto-Bold',
    textAlign: 'center',
    color: '#0092E5',
    border: '2px solid #0092E5',
    borderRadius: 5,

    [theme.breakpoints.down(450)]: {
      width: 45,
    },
    [theme.breakpoints.down(425)]: {
      width: 40,
    },
    [theme.breakpoints.down(400)]: {
      width: 35,
    }
  },
  itemActive: {
    color: '#FFFFFF',
    backgroundColor: '#0092E5',
  },
  headline: {
    marginBottom: 20,
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
  },
});

export default styles;